<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.video_instructions.h1')}}</h1>
    </div>
    <div class="content">
      <div class="wrapper-x-40">
        <div
          class="video_instructions"
          v-if="videos&&videos.length"
        >
          <video-instruction-item
            v-for="video,i in videos"
            :key="`vinst-${video.id||video.tempId}`"
            :item="video"
            :posNumber="i+1"
          />
        </div>
        <div v-else>
          {{$t('admin.views.video_instructions.no_exists')}}
        </div>
        <div
          class="mt-4"
          v-if="videos.length<7"
        >
          <button
            @click="addVideo"
            class="btn btn-small btn-green"
          >
            {{$t('admin.views.video_instructions.add')}}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import VideoInstructionItem from "../../components/Admin/VideoInstructions/VideoInstructionItem.vue";
export default {
  name: "VideoInstructions",
  components: { VideoInstructionItem },
  data() {
    return {};
  },
  computed: {
    videos() {
      return this.$store.state.videoInstructions.videos;
    },
    license() {
      return this.$store.state.license;
    },
  },

  methods: {
    addVideo() {
      const newVideo = {
        tempId: uuidv4(),
        name: "",
        code: "",
      };
      this.$store.dispatch("videoInstructions/addTempVideo", newVideo);
    },
  },
};
</script>
<style scoped>
.video_instructions {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
</style>

